import { memo, ReactNode } from "react";

import { Group, Title } from "@mantine/core";

interface FormTitleProps {
  title: string;
  buttons: ReactNode | ReactNode[];
}

const FormTitle = ({ title, buttons }: FormTitleProps) => {
  return (
    <Group position="apart" mb={24} noWrap align="flex-start">
      <Title order={3} fw={500}>
        {title}
      </Title>
      <Group spacing={8}>{buttons}</Group>
    </Group>
  );
};

export default memo(FormTitle);
